<div style="margin: 20px; min-height: 700px; min-width: 1200px;">
  <h2>Lista walidatorów</h2>
  <p-table [value]="data" [paginator]="true" [rows]="limit" [(first)]="parent.first">
    <ng-template pTemplate="header">
      <tr style="white-space: nowrap;">
        <th width="10%">Id</th>
        <th width="20%">Skrót</th>
        <th width="25%">Nazwa SkiData</th>
        <th width="25%">Nazwa</th>
        <th width="10%">Aktywny</th>
        <th width="10%">Akcja</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-validationProvider>
      <tr style="white-space: normal; overflow-wrap: break-word;">
        <td>{{validationProvider.id}}</td>
        <td>{{validationProvider.abbreviation}}</td>
        <td>{{validationProvider.name}}</td>
        <td>{{validationProvider.label}}</td>
        <td>{{validationProvider.active ? 'Tak' : 'Nie'}}</td>
        <td>
          <fa-stack size="1x" style="cursor: pointer; float: right;" (click)="gotoDetails(validationProvider)" title="Szczegóły">
            <fa-icon icon="square" stackItemSize="2x"></fa-icon>
            <fa-icon icon="edit" [inverse]="true" stackItemSize="1x"></fa-icon>
          </fa-stack>
          <fa-stack size="1x" style="cursor: pointer; float: right;" [routerLink]="'./' + validationProvider.id + '/configs'" title="Konfiguracje">
            <fa-icon icon="square" stackItemSize="2x"></fa-icon>
            <fa-icon icon="bars" [inverse]="true" stackItemSize="1x"></fa-icon>
          </fa-stack>
          <fa-stack size="1x" style="cursor: pointer; float: right;" (click)="gotoOptions(validationProvider)" title="Opcje">
            <fa-icon icon="square" stackItemSize="2x"></fa-icon>
            <fa-icon icon="cog" [inverse]="true" stackItemSize="1x"></fa-icon>
          </fa-stack>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
